import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ContentProvider, useContent } from "@/contexts/ContentContext";
import { CraneMarkDefs } from "@/components/CraneMark";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { AdminBar } from "@/components/AdminBar";
import { AuthModal } from "@/components/AuthModal";
import { AdminManageModal } from "@/components/AdminManageModal";
import { ResourcesEditModal } from "@/components/ResourcesEditModal";
import Home from "@/pages/Home";
import PracticeDetail from "@/pages/PracticeDetail";
import VideosPage from "@/pages/VideosPage";

function Shell() {
  const [authOpen, setAuthOpen] = useState(false);
  const [manageOpen, setManageOpen] = useState(false);
  const [resourcesOpen, setResourcesOpen] = useState(false);
  const { admin } = useAuth();
  const { setEditMode } = useContent();

  function handleAdminClick() {
    if (admin) setEditMode(true);
    else setAuthOpen(true);
  }

  return (
    <div className="App">
      <CraneMarkDefs />
      <Header onAdminClick={handleAdminClick} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/practice/:slug" element={<PracticeDetail />} />
        <Route path="/videos" element={<VideosPage />} />
      </Routes>
      <Footer onAdminClick={handleAdminClick} />
      <AdminBar onManageAdmins={() => setManageOpen(true)} onEditResources={() => setResourcesOpen(true)} />
      <AuthModal open={authOpen} onOpenChange={setAuthOpen} />
      {admin && <AdminManageModal open={manageOpen} onOpenChange={setManageOpen} />}
      {admin && <ResourcesEditModal open={resourcesOpen} onOpenChange={setResourcesOpen} />}
      <Toaster position="top-center" />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ContentProvider>
          <Shell />
        </ContentProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
